<template>
  <div
    class="bg-grey-800 flex flex-col w-64"
    style="height: calc(100vh - 3.25rem)"
  >
    <div class="heading flex flex-row justify-between">
      <div class="flex flex-column items-center h-16" @click="close">
        <span v-if="!doNotClose" class="pl-4 pr-2">
          <left-arrow-icon class="w-4 h-6 fill-current"></left-arrow-icon>
        </span>
        <span
          class="heading-lg lg:font-normal"
          :class="{ 'ml-4': doNotClose }"
          >{{ $t('frontend_sites_side_bar_left_switch_to') }}</span
        >
      </div>
    </div>
    <div class="w-full px-4 flex flex-col justify-center">
      <gd-button
        v-if="!futureGrooveAppsUser"
        primary
        size="auto"
        class="mr-4 p-4 mt-3"
        @click="goToUpgradePage"
        >{{ $t('frontend_sites_side_bar_left_upgrade') }}</gd-button
      >
      <gd-button
        transparent
        size="auto"
        class="mr-4 p-4 mt-3"
        @click="goToPartnerProgram"
        >{{ $t('frontend_sites_side_bar_groove_affiliate_program') }}</gd-button
      >
    </div>
    <div id="style-3" class="overflow-y-auto flex flex-col flex-grow mt-4">
      <expansion-group class>
        <expansion-panel
          class="-ml-0"
          flat="true"
          :show-gd-logo="true"
          :open-on-load="expandedMenuItem == 'groovefunnels'"
          title="Groove.cm"
          @open="panelOpened('groovefunnels')"
        >
          <a href="/groovepages/" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{ $t('frontend_gduikit_page_and_funnels') }}</span>
          </a>
          <a href="/groovesell/" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{ $t('frontend_gduikit_sell_product') }}</span>
          </a>
          <a
            href="/groovesell/affiliates-dashboard"
            class="pl-8 mb-4 flex items-center"
          >
            <span class="text-white ml-2 text-sm">{{ $t('frontend_gduikit_affiliate_earnings') }}</span>
          </a>

          <a href="/groovemail/" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">Mail</span>
          </a>
          <a href="/groovemember/" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{ $t('frontend_memberships') }}</span>
          </a>
          <a href="/groovevideo/" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">Video</span>
          </a>
          <a href="/grooveblog/" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">Blog</span>
          </a>
          <a href="/static/groovekart" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">eCommerce</span>
          </a>
          <a href="/groovewebinar/" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{ $t('frontend_sites_template_webinars') }}</span>
          </a>
        </expansion-panel>

        <expansion-panel
          class="-ml-0"
          flat="true"
          :title="$t('frontend_builder_our_services')"
          :open-on-load="expandedMenuItem == 'our_services'"
          @open="panelOpened('our_services')"
        >
          <a href="/static/groovepay" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_groovepay')
            }}</span>
          </a>
          <a href="/static/grooveads" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_grooveads')
            }}</span>
          </a>
          <a
            href="https://groovesolos.com/"
            target="_blank"
            class="pl-8 mb-4 flex items-center"
          >
            <span class="text-white ml-2 text-sm">GrooveSolos</span>
          </a>
          <a
            href="/static/groovecopypro"
            target="_blank"
            class="pl-8 mb-4 flex items-center"
          >
            <span class="text-white ml-2 text-sm">GrooveCopyPro</span>
          </a>
          <a
            href="https://groovedesignerpro.com/"
            target="_blank"
            class="pl-8 mb-4 flex items-center"
          >
            <span class="text-white ml-2 text-sm">GrooveDesignerPro</span>
          </a>
        </expansion-panel>

        <expansion-panel
          class="-ml-0"
          flat="true"
          :title="$t('frontend_builder_events_and_workshop')"
          :open-on-load="expandedMenuItem == 'events_workshops'"
          @open="panelOpened('events_workshops')"
        >
          <a
            href="https://groovekon.com"
            class="pl-8 mb-4 flex items-center"
            target="_blank"
          >
            <span class="text-white ml-2 text-sm">GrooveKon</span>
          </a>

          <a
            href="https://marketerscruise.com/"
            target="_blank"
            class="pl-8 mb-4 flex items-center"
          >
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_marketers_cruise')
            }}</span>
          </a>
        </expansion-panel>

        <expansion-panel
          class="-ml-0"
          flat="true"
          :title="$t('frontend_builder_marketplace')"
          :open-on-load="expandedMenuItem == 'marketplace'"
          @open="panelOpened('marketplace')"
        >
          <a href="/groovesell/marketplace" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_groove_affiliate_market')
            }}</span>
          </a>
          <a
            href="/static/groovemarketplace"
            class="pl-8 mb-4 flex items-center"
          >
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_groove_market_place')
            }}</span>
          </a>
        </expansion-panel>

        <hr
          style="
            border-top: dashed 2px #ffffff;
            margin-right: 1rem;
            margin-left: 1rem;
            margin-top: 1rem;
          "
        />
        <div class="text-lg text-white mx-2 mt-4">{{ $t('frontend_planned') }}</div>

        <expansion-panel
          class="-ml-0"
          flat="true"
          title="Planned Development"
          :open-on-load="expandedMenuItem == 'future_groovefunnels'"
          @open="panelOpened('future_groovefunnels')"
        >
          <a href="/static/groovedesk" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_groove_desk')
            }}</span>
          </a>
          <a href="/static/groovecalendar" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_groove_calender')
            }}</span>
          </a>
          <a href="/static/groovesurvey" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_groove_survey')
            }}</span>
          </a>
        </expansion-panel>

        <expansion-panel
          class="-ml-0"
          flat="true"
          :title="$t('frontend_builder_app_store')"
          :open-on-load="expandedMenuItem == 'app_store'"
          @open="panelOpened('app_store')"
        >
          <a href="/static/grooveappstore" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_multi_vendor')
            }}</span>
          </a>
        </expansion-panel>

        <expansion-panel
          class="-ml-0"
          flat="true"
          :title="$t('frontend_builder_sdk')"
          :open-on-load="expandedMenuItem == 'sdk_api'"
          @open="panelOpened('sdk_api')"
        >
          <a href="/static/grooveapidocs" class="pl-8 mb-4 flex items-center">
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_api_docs')
            }}</span>
          </a>
          <a
            href="/static/groovedevelopers"
            class="pl-8 mb-4 flex items-center"
          >
            <span class="text-white ml-2 text-sm">{{
              $t('frontend_sites_side_bar_app_developers')
            }}</span>
          </a>
        </expansion-panel>
      </expansion-group>

      <div class="mt-8 text-center">
        <a
          @click="routeToGrooveDigitalAcademy"
          class="mt-2 ml-8 mb-4 flex items-center cursor-pointer"
        >
          <span class="text-white ml-2 text-sm">{{
            $t('frontend_sites_side_bar_groovedigital_academy')
          }}</span>
        </a>

        <a
          @click="routeToGrooveTutorials"
          class="mt-2 ml-8 mb-4 flex items-center cursor-pointer"
        >
          <span class="text-white ml-2 text-sm">{{
            $t('frontend_sites_side_bar_tutorials')
          }}</span>
        </a>

        <a
          @click="routeToGrooveBlog"
          class="mt-2 ml-8 mb-4 flex items-center cursor-pointer"
        >
          <span class="text-white ml-2 text-sm">{{
            $t('frontend_sites_side_bar_left_blog')
          }}</span>
        </a>
        <a
          @click="routeToGrooveSupport"
          class="mt-2 ml-8 mb-4 flex items-center cursor-pointer"
        >
          <span class="text-white ml-2 text-sm">{{
            $t('frontend_sites_side_bar_left_heldesk')
          }}</span>
        </a>
        <a
          @click="routeToGrooveCorporateSite"
          class="mt-2 ml-8 mb-4 flex items-center cursor-pointer"
        >
          <span class="text-white ml-2 text-sm">{{
            $t('frontend_sites_side_bar_left_corporate_site')
          }}</span>
        </a>
        <a
          @click="routeToGrooveFacebookGroup"
          class="mt-2 ml-8 mb-4 flex items-center cursor-pointer"
        >
          <span class="text-white ml-2 text-sm">{{
            $t('frontend_sites_side_bar_left_facebook_group')
          }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LeftArrowIcon from '@fortawesome/fontawesome-free/svgs/solid/angle-left.svg';
import auth from '@groovepages/gd-lib/auth';
import store from '@groovepages/gd-lib/core-store';
import GdLogo from '../assets/logo-extra-small.svg';
import ExpansionPanel from './ExpansionPanel';
import ExpansionGroup from './ExpansionGroup';
import GdButton from './Button';

export default {
  name: 'SideBarLeft',
  components: {
    LeftArrowIcon,
    ExpansionPanel,
    ExpansionGroup,
    GdButton,
  },
  props: {
    doNotClose: { default: false },
  },
  data() {
    return {
      groovesellUser: false,
      futureGrooveAppsUser: false,
      isAdmin: null,
    };
  },
  computed: {
    expandedMenuItem() {
      if (localStorage.getItem('expandedMenuItem')) {
        return localStorage.getItem('expandedMenuItem');
      }
      return 'groovefunnels';
    },

    webinarUrl() {
      if (this.isAdmin) {
        return '/groovewebinar/';
      }
      return '/static/groovewebinars';
    },
  },
  mounted() {
    if (!auth.authenticatedUser()) return;
    this.groovesellUser =
      auth.authenticatedUser().roles.indexOf('groovesell_user') !== -1;
    this.futureGrooveAppsUser =
      auth.authenticatedUser().roles.indexOf('groovepages_user') !== -1;
  },
  async created() {
    this.isAdmin = store.state.user.admin;
  },
  methods: {
    routeToGrooveDigitalAcademy() {
      window.open(this.$t('official_link_academy'), '_blank');
    },

    routeToGrooveTutorials() {
      window.open(this.$t('official_link_tutorials'), '_blank');
    },

    routeToGrooveBlog() {
      window.open(this.$t('official_link_blog'), '_blank');
    },

    routeToGrooveSupport() {
      window.open(this.$t('official_link_support'), '_blank');
    },

    routeToGrooveCorporateSite() {
      window.open(this.$t('official_link_corporate'), '_blank');
    },

    routeToGrooveFacebookGroup() {
      window.open(this.$t('official_link_facebook_group'), '_blank');
    },

    panelOpened(menuItem) {
      localStorage.setItem('expandedMenuItem', menuItem);
    },

    close() {
      if (!this.doNotClose) {
        this.$emit('closeSideBar', false);
      }
    },

    goToUpgradePage() {
      let user = auth.authenticatedUser();
      let url = window.gdEnv['UPGRADE_URL'];

      if( user && user.metadata && user.metadata.region )
        url = window.gdEnv['UPGRADE_URL_'+user.metadata.region.toUpperCase()];
      
      window.open(url, '_blank');
    },

    goToPartnerProgram() {
      let url = '/static/partner-program';
      window.open(url, '_self');
    },
  },
};
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
